export { MiniMap } from './MiniMap';
